import React, { useEffect } from 'react';
import { SWRConfig } from 'swr';
import { ApolloProvider } from '@apollo/client/react';
import Bugsnag from '@bugsnag/js';
import Script from 'next/script';
import { initAppClient, initAppServer } from '../lib/setup';
import client from '../lib/apolloClient';
import { BaseAppContextProvider } from '../context/base-context';

import type { AppProps } from 'next/app';

import '../styles/index.css';

initAppServer();

const BugsnagErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);

function App({ Component, pageProps }: AppProps) {
	useEffect(() => {
		initAppClient();

		const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
			if (event.reason instanceof Error) {
				Bugsnag.notify(event.reason);
			} else {
				Bugsnag.notify(new Error('Unhandled rejection: ' + event.reason));
			}
		};

		window.addEventListener('unhandledrejection', handleUnhandledRejection);

		return () => {
			window.removeEventListener('unhandledrejection', handleUnhandledRejection);
		};
	}, []);

	return (
		<BugsnagErrorBoundary>
			<SWRConfig value={{ revalidateOnFocus: false }}>
				<ApolloProvider client={client}>
					<BaseAppContextProvider>
						<Component {...pageProps} />
					</BaseAppContextProvider>
				</ApolloProvider>
			</SWRConfig>
			<Script
				id="leadfeeder"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `(function(ss,ex){ window.ldfdr=window.ldfdr||function(){(ldfdr._q=ldfdr._q||[]).push([].slice.call(arguments));}; (function(d,s){ fs=d.getElementsByTagName(s)[0]; function ce(src){ var cs=d.createElement(s); cs.src=src; cs.async=1; fs.parentNode.insertBefore(cs,fs); }; ce('https://sc.lfeeder.com/lftracker_v1_'+ss+(ex?'_'+ex:'')+'.js'); })(document,'script'); })('kn9Eq4R3oxJaRlvP');`,
				}}
			/>
			<Script id="brevo-sdk" src="https://cdn.brevo.com/js/sdk-loader.js" strategy="afterInteractive" />
			<Script
				id="brevo-init"
				strategy="afterInteractive"
				dangerouslySetInnerHTML={{
					__html: `window.Brevo = window.Brevo || []; Brevo.push(["init", { client_key: "jvdrjafcai9irnex05e7mb6k" }]);`,
				}}
			/>
		</BugsnagErrorBoundary>
	);
}

export default App;
